<template>
  <div class="row page-wrapper no-gutters">
    <div class="col-12">
      <div class="page-content">
        <div class="row img-logo-container justify-content-center no-gutters">
          <div class="col-12">
            <img
              class="img-logo"
              :src="logo"
            >
          </div>
        </div>
        <div class="row header justify-content-center no-gutters">
          <div class="col-12">
            <h3>Willkommen</h3>
          </div>
        </div>
        <div class="row text-logo-container justify-content-center no-gutters">
          <div class="col col-xs-12 col-md-8 col-lg-6 col-xl-4">
            <img
              class="img-logo-text"
              :src="logoText"
            >
          </div>
        </div>
        <div class="row form-container justify-content-center no-gutters">
          <div class="col col-xs-12 col-md-8 col-lg-6 col-xl-4 no-gutters">
            <b-form
              @submit="onSubmit"
            >
              <b-form-group>
                <b-form-input
                  v-model="formData.email"
                  type="email"
                  class="form-control"
                  placeholder="E-mail"
                />
              </b-form-group>
              <b-form-group>
                <b-form-input
                  v-model="formData.password"
                  type="password"
                  class="form-control"
                  placeholder="Passwort"
                />
              </b-form-group>
              <b-button
                type="submit"
                variant="primary"
                class="btn-sign-in"
                :disabled="!isFormValid"
              >
                Anmelden
              </b-button>
            </b-form>
          </div>
        </div>
        <div class="volume-footer">
          <span>Volume {{ volume }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {AuthMixin, NavigationMixin} from '../../mixins';
import logo from '../../assets/R.svg';
import logoText from '../../assets/License_Management.svg';
import appConfig from '../../app.config';

export default {
  name: 'SignIn',
  mixins: [AuthMixin, NavigationMixin],
  data: function () {
    return {
      formData: {email: null, password: null},
      isFormValid: false,
      logo: logo,
      logoText: logoText,
      volume: appConfig.volume
    };
  },
  watch: {
    formData: {
      handler: function (value) {
        this.isFormValid =
            (typeof value.email === 'string' && value.email !== '') &&
            (typeof value.password === 'string' && value.password !== '');
      },
      deep: true
    }
  },
  created() {
    if (this.isAuthenticated) {
      this.goToHomePage();
    }
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      if (this.isFormValid) {
        try {
          const auth = await this.authService.signIn({
            email: this.formData.email,
            password: this.formData.password
          });
          this.setAuth(auth);
          this.goToPath(this.$route.query.redirect_uri);
        } catch (err) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'Anmelden',
            text: err.message
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
  .btn-sign-in {
    width: 100%;
  }

  .page-wrapper {
    background: #FFFFFF;
    height: 100vh;
  }

  .page-content {
    padding: 30px 0px 30px 0px;
    height: 100%;
  }

  .img-logo-container, .text-logo-container, .header {
    text-align: center;
  }

  .header {
    margin-top: 20px;

    h3 {
      margin-left: 0;
    }
  }

  .text-logo-container {
    margin-top: 10px;
  }

  .form-container {
    margin-top: 25px;
  }

  .img-logo {
    height: 46px;
    margin-top: 20px;
  }

  .img-logo-text {
    max-height: 38px;
    width: 100%;
  }

  .btn {
    height: 50px;
    line-height: 24px;
    font-size: 20px;
  }

  @media(min-width: 425px) {
    .img-logo {
      margin-top: 40px;
    }

    .header {
      margin-top: 40px;
    }

    .text-logo-container {
      margin-top: 20px;
    }
  }

  @media(min-width: 768px) {
    .img-logo {
      margin-top: 80px;
    }
  }

  @media(min-width: 1440px) {
    .form-container {
      margin-top: 35px;
    }

    .img-logo {
      margin-top: 120px;
    }
  }

  .volume-footer {
    text-align: center;
    position: absolute;
    bottom: 10px;
    width: 100%;

    span {
      color: #8E8E8E;
    }
  }
</style>
